import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

function FormattedDate({
    date,
    locale,
    timeZone,
    showTime = true,
    showDate = true,
    showSeconds = false
}) {
    const [formattedDate, setFormattedDate] = useState('');
    const { t } = useTranslation('common');

    useEffect(() => {
        try {
            const dateObj = new Date(date);
            const options = {
                year: showDate ? 'numeric' : undefined,
                month: showDate ? 'numeric' : undefined,
                day: showDate ? 'numeric' : undefined,
                hour: showTime ? 'numeric' : undefined,
                minute: showTime ? 'numeric' : undefined,
                second: showTime && showSeconds ? 'numeric' : undefined,
                timeZone: 'Europe/Copenhagen'
            };

            // Compact, time-only mode (used by the homepage "live" indicator)
            // drops the calendar date and the "(Copenhagen time)" suffix.
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setFormattedDate(
                showDate
                    ? dateObj.toLocaleString(locale || 'en-US', options) +
                          ' ' +
                          t('local_time')
                    : dateObj.toLocaleString(locale || 'en-US', options)
            );
        } catch (error) {
            console.log('error', error);
            setFormattedDate('Invalid Date');
        }
    }, [date, locale, timeZone, showTime, showDate, showSeconds, t]);

    // Return empty div for initial server render
    if (!formattedDate) {
        return <span>-</span>;
    }

    return <span>{formattedDate}</span>;
}

export default FormattedDate;
